import { http } from '@/utils'

export const flowInstNodeApi = (data: any): any =>
  http.get(`/workflow/inst_hotchpotch/${data}?type=1`, {})
